import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'formik';
import FieldInput from 'common/components/FieldInput';
import styles from './styles.module.scss';
import TooltipContainer from "../../../../../../common/components/TooltipContainer";

const FormForgotPasswordSetNewView = ({values}) => {
  return (
    <div className={styles.forgotPasswordSetNew}>
      <h2>איפוס ססמה</h2>
      <p className={styles.description}>קוד אימות נשלח אל כתובת האימייל המשוייכת
        לחשבון אנא הזן את קוד האימות לאיפוס הססמה</p>
      <Form>
        <div className={styles.verificationCode}>
          <FieldInput
            fieldId="verificationCode"
            value={values.verificationCode}
            label="קוד אימות"
            disabled
            classNames={{
              input: styles.input,
              label: styles.label,
            }}
          />
        </div>
        <div className={styles.newPassword}>
          <FieldInput
            fieldId="newPassword"
            type={'password'}
            value={values.newPassword}
            label={(
              <div className={styles.flexStart}>
                <span className={styles.labelMargin}>ססמה חדשה</span>
                <TooltipContainer
                  label={
                    <div>
                      <p>סיסמה צריכה להכיל לפחות 8 תוים</p>
                      <p>סיסמה חייבת להכיל ספרה, אות גדולה ואות קטנה</p>
                    </div>
                  }
                />
              </div>
            )}
            showBird={false}
            classNames={{
              input: styles.input,
              label: styles.label,
            }}
            peepPassword={true}
          />
        </div>
        <div className={styles.newPasswordConfirm}>
          <FieldInput
            fieldId="newPasswordConfirm"
            type={'password'}
            value={values.newPasswordConfirm}
            label={(
              <div className={styles.flexStart}>
                <span className={styles.labelMargin}>אימות ססמה חדשה</span>
                <TooltipContainer
                  label={
                    <div>
                      <p>סיסמה צריכה להכיל לפחות 8 תוים</p>
                      <p>סיסמה חייבת להכיל ספרה, אות גדולה ואות קטנה</p>
                    </div>
                  }
                />
              </div>
            )}
            showBird={false}
            classNames={{
              input: styles.input,
              label: styles.label,
            }}
            peepPassword={true}
          />
        </div>
        <button
          type="submit"
          className={styles.buttonSend}>
          <span>אישור</span>
        </button>
      </Form>
    </div>
  );
};

FormForgotPasswordSetNewView.propTypes = {
  values: PropTypes.object
};

export default FormForgotPasswordSetNewView;
